// types
import { Control } from 'react-hook-form';

// components
import { Box, styled } from '@mui/material';
import {
  ControlledCheckbox,
  ControlledTextField
} from 'components/shared/ControlledFields';

// hooks
import { useTranslation } from 'react-i18next';

const SpacedBox = styled(Box)(({ theme }) => ({
  gap: theme.spacing(2.5),
  display: 'flex',
  flexDirection: 'column',
  paddingTop: theme.spacing(4)
}));

export const BaseResourceSection = ({ control }: { control: Control<any> }) => {
  const { t } = useTranslation('common');
  return (
    <SpacedBox>
      <ControlledTextField
        name="code"
        control={control}
        variant="outlined"
        label={t('adminPortal.resources.code')}
      />
      <ControlledTextField
        name="name"
        control={control}
        variant="outlined"
        label={t('adminPortal.resources.name')}
      />
      <ControlledTextField
        name="description"
        control={control}
        variant="outlined"
        label={t('adminPortal.resources.description')}
      />
      <ControlledCheckbox
        name="checkOverlap"
        control={control}
        label={t('adminPortal.resources.checkOverlap')}
      />
    </SpacedBox>
  );
};
